import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { BillStatusColors } from 'constants/private/financial/billStatusColors';

export function getPillColor(status: string = ''): string {
  return BillStatusColors[status?.toLowerCase()] ?? NEW_COLORS.GRAYSCALE[700];
}
